<template>
  <button
    :type="type"
    class="
      inline-flex
      items-center
      px-4
      py-2
      border border-transparent
      text-xs
      tracking-widest
      font-medium
      rounded-md
      text-white
      bg-vice-teal-600
      hover:bg-vice-teal-700
      focus:outline-none
      focus:ring-2 focus:ring-offset-2 focus:ring-vice-teal-500
    "
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'submit',
    },
  },
};
</script>
